import type { CartItem, DetailedSaleItem, ProductPackageProduct, PackageGroup } from '@src/domains/cart/types/cart';

export function groupItemsByProductPackage<T extends CartItem | DetailedSaleItem>(items: T[]) {
  const grouped: Record<string, PackageGroup<T>> = {};
  const nonPackageItems: T[] = [];

  for (const item of items) {
    if (item.productPackageUnitId) {
      const productPackageProduct = item.productPackageProduct as ProductPackageProduct;
      const productPackage = productPackageProduct.productPackage;

      if (!grouped[item.productPackageUnitId]) {
        grouped[item.productPackageUnitId] = {
          productPackage: productPackage!,
          items: [],
        };
      }

      grouped[item.productPackageUnitId]!.items.push(item);
    } else {
      nonPackageItems.push(item);
    }
  }

  return {
    packages: Object.values(grouped),
    nonPackageItems,
  };
}

export const groupSaleItemsByProductPackage = (items: DetailedSaleItem[]) => groupItemsByProductPackage(items);
export const groupCartItemsByProductPackage = (items: CartItem[]) => groupItemsByProductPackage(items);
